import { render, staticRenderFns } from "./mem_inside_part_reserv.vue?vue&type=template&id=33cde65e&scoped=true&"
import script from "./mem_inside_part_reserv.vue?vue&type=script&lang=js&"
export * from "./mem_inside_part_reserv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cde65e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33cde65e')) {
      api.createRecord('33cde65e', component.options)
    } else {
      api.reload('33cde65e', component.options)
    }
    module.hot.accept("./mem_inside_part_reserv.vue?vue&type=template&id=33cde65e&scoped=true&", function () {
      api.rerender('33cde65e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/body/addon/parts_reserv/mem_inside_part_reserv.vue"
export default component.exports